import React from 'react';
import { motion } from 'framer-motion';
import { bookInfo } from '../../data/bookData';

const AuthorHero = () => (
  <section className="relative min-h-[60vh] flex items-end pt-28 pb-0 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-b from-brand-surfaceLight via-brand-dark to-brand-dark"></div>
    <div className="absolute top-1/3 right-1/3 w-96 h-96 bg-brand-accent/5 blur-[150px] rounded-full"></div>
    <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10 w-full pb-16">
      <div className="flex flex-col md:flex-row items-center md:items-end gap-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          className="flex-shrink-0"
        >
          <div className="w-48 h-48 md:w-64 md:h-64 rounded-2xl overflow-hidden border-2 border-brand-accent/30 shadow-2xl shadow-brand-accent/10 relative group">
            <div className="absolute inset-0 bg-brand-accent/10 mix-blend-overlay group-hover:bg-transparent transition-colors duration-500 z-10"></div>
            <img
              src={bookInfo.authorImage}
              alt={bookInfo.author}
              className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700"
            />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-center md:text-left"
        >
          <p className="text-brand-accent font-semibold tracking-widest uppercase text-sm mb-3">Meet the Author</p>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-white mb-4 text-glow">{bookInfo.author}</h1>
          <p className="text-gray-400 text-lg max-w-xl">
            Creator of the expansive universe of <em className="text-white">The Quantum Awakening</em> — a panoramic vision of humanity's future across five centuries and the solar system.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);

export default AuthorHero;